import React from 'react'
import * as Icon from '@mui/icons-material';

export default function ({ type, color, sx }) {
    const DynamicComponent = Icon[type]

    return <DynamicComponent color={color} />
}